import HighlightComponent, { HighlightProps } from "./Highlight";
import { Container } from "./styles";
import React from "react";

// Cast to fix React 17 + @types/react 18 compatibility issue
const Highlight = HighlightComponent as any;

type Props = {
  highlights?: HighlightProps[];
};

/**
 * @see https://www.figma.com/file/16YSFRr06xdFYJFqNgvv41/Bormioli-Product-Design?node-id=67%3A5987
 */
const Highlights: React.FC<Props> = (props) => {
  const { highlights: items } = props;
  return (
    <Container>
      {items &&
        items.map((item, index) => (
          <Highlight {...item} key={`highlight-${index}`} />
        ))}
    </Container>
  );
};

export default Highlights;
